module.exports = __webpack_public_path__ + "static/img/Frame 1924.4beba4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper3/Frame 1924.png
// module id = FN4j
// module chunks = 13